import { Injectable } from '@angular/core';
import { IS1SearchParams, S1HttpClientService } from '@app/s1/s1-http-client.service';
import { Observable, map } from 'rxjs';
import { CheckType, IBaseOption } from '../models/models';

export interface ISearchEnteCommessaParams extends IS1SearchParams {
  ente: string,
  anno: number[]
}

export interface ISearchAnnoCommessaParams extends IS1SearchParams { 
  ente: string[],
  anno: number
}

export interface ISearchNumeroCommessaParams extends IS1SearchParams { 
  ente: string[],
  anno: number[]
  numero: string
}

enum CommessaApi {
  enti = "/enti",
  anni = "/anni",
  numeri = "/numeri"
}

@Injectable({
  providedIn: 'root'
})
export class CommessaService {

  path = "/commessa";

  constructor(private s1HttpClient: S1HttpClientService) { }

  getEnti(parameters: ISearchEnteCommessaParams, type: CheckType, ui: boolean = false): Observable<IBaseOption[]> {
    return this.s1HttpClient.get(`/${type}${this.path}${CommessaApi.enti}`, parameters, ui).pipe(
      map(response => response.data.results)
    )
  }

  getAnni(parameters: ISearchAnnoCommessaParams, type: CheckType, ui: boolean = false): Observable<IBaseOption[]> {
    return this.s1HttpClient.get(`/${type}${this.path}${CommessaApi.anni}`, parameters, ui).pipe(
      map(response => response.data.results)
    )
  }

  getNumeri(parameters: ISearchNumeroCommessaParams, type: CheckType, ui: boolean = false): Observable<IBaseOption[]> {
    return this.s1HttpClient.get(`/${type}${this.path}${CommessaApi.numeri}`, parameters, ui).pipe(
      map(response => response.data.results)
    )
  }

}
